import React from 'react';
export function MeetSystem() {
  return <section aria-labelledby="meet-title" className="w-full bg-white px-3 py-6 sm:px-5" data-id="element-170" data-mp="14pmftbrsr48m">
      <div className="mx-auto max-w-3xl text-center" data-id="element-171" data-mp="mpeag7tkn7f9">
        <span className="font-head text-[10px] uppercase tracking-[0.14em] text-blue sm:text-xs" data-id="element-172" data-mp="10nm70emp46pw">
          Meet Kids Learning Ready™
        </span>
        <h2 id="meet-title" className="mt-1 font-head text-2xl uppercase leading-[0.98] text-navy sm:text-4xl" data-id="element-173" data-mp="wkpiy8edziek">
          One complete system for easier learning.
        </h2>
        <p className="mx-auto mt-1.5 max-w-2xl text-[13px] leading-snug text-muted sm:text-base" data-id="element-174" data-mp="15lxfom198b6j">
          A ready-to-use visual learning system that turns essential concepts into clear, colorful
          and easy-to-understand resources children can return to again and again.
        </p>

        <ul className="mt-3 flex flex-wrap justify-center gap-1.5" data-id="element-175" data-mp="1tbrsx4phk1rb">
          {['No complicated explanations.', 'No endless searching.', 'No starting from zero.'].map(item => <li key={item} className="rounded-full border border-line bg-soft px-3 py-1 text-[11px] font-semibold text-navy sm:text-[13px]" data-id="element-176" data-mp="28cp7728vwvna">
              {item}
            </li>)}
        </ul>

        <p className="mt-3 font-head text-lg uppercase leading-tight text-green sm:text-2xl" data-id="element-177" data-mp="2ddlkg6f4lu5d">
          See it. Understand it. Remember it.
        </p>
      </div>
    </section>;
}